export enum LaunchType {
  Now,
  Delayed,
  None,
}
